import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import React from "react";
import { updateProjectShortCut } from '../../actions/userDashboardAction';
import Tooltip from "react-simple-tooltip"
import moment from "moment";
import {MEMBER} from '../../constants/constants';

const ProjectDashboard = (props) => {
    const { user } = useSelector(state => state.auth);
    const pinToShortCut = (project) => {
        let projectData = {
            project_id: project.id,
            is_in_shortcuts: !project.is_in_shortcuts
        }
        // dispatch(updateProjectShortCut(projectData));
        // props.refreshProject()
        return updateProjectShortCut(projectData)
            .then(props.refreshProject)
    }
    return (
        <>
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="card card-radius">
                    <div className="header card-header custum-bg-warning rounded">
                        <h2 className="text-white">My Pipeline</h2>
                        {
                           (user?.userType === MEMBER) ?<></> :<Link to='/project-create' className=" dropdown dropdown-animated scale-left text-white"><i className="fa fa-plus-circle mr-2"></i>Create New Project</Link>
                        }
                    </div>
                    <div className="body card-body-shadow">
                        <div className="table-responsive mt-4">
                            <table className="table table-hover table-custom mb-0" style={{ "minHeight": "100px" }}>
                                <thead className="">
                                    <tr>
                                        <th width={20} >Job Number</th>
                                        <th width={20}>Job Description</th>
                                        <th width={20}>Start Date</th>
                                        <th width={20}>Due Date</th>
                                        <th width={20}>Project Status</th>
                                        <th width={20}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {props.projects && props.projects.map((project, index) => (
                                        <tr key={index}>
                                            <td>
                                                <div className="row">
                                                    <div className="col-sm-6">
                                                        <Link to={`/schedule-details/${project.id}`}>
                                                            {project.job_number}
                                                        </Link>
                                                    </div>
                                                    <span onClick={() => pinToShortCut(project)}>
                                                        {project.is_in_shortcuts ?
                                                            <Tooltip 
                                                            arrow={8}
                                                            background="#fa7a13"
                                                            color="#fff"
                                                            border="0"
                                                            fontSize="8"
                                                            fontFamily="sans-serif"
                                                            padding={8}
                                                            placement="bottom"
                                                            radius={5}
                                                            zIndex={1}
                                                            content="Remove from shortcut">
                                                                <i className="fa fa-thumb-tack"></i> 
                                                            </Tooltip>
                                                            :
                                                            <Tooltip 
                                                            arrow={8}
                                                            background="#fa7a13"
                                                            color="#fff"
                                                            border="0"
                                                            fontSize="8"
                                                            padding={8}
                                                            fontFamily="sans-serif"
                                                            placement="bottom"
                                                            radius={5}
                                                            zIndex={1}
                                                            content="Add to shortcut">
                                                                <i className="icon-pin"></i>
                                                            </Tooltip>
                                                        }
                                                    </span>
                                                </div> </td>
                                            <td>{project.title}</td>
                                            <td>{ moment(project.project_start_date).format('DD/MM/YYYY') }</td>
                                            <td>{ moment(project.project_end_date).format('DD/MM/YYYY') }</td>
                                            {/* <td width={20}>{project.agency_name ? project?.agency_name.substring(0,20) : 'N/A'}</td> */}
                                            <td >
                                            <span className="bg_new_status">
                                            {project.project_status}
                                            </span>
                                            </td>
                                            <td>
                                                <Link to={`/project/${project.id}`} className="btn btn-sm round custom-btn-outline-info"><i className="fa fa-edit"></i></Link>
                                            </td>
                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                            <div className="text-center my-4">
                                <Link to={'/activity-schedule'} className="button btn text-white">View schedule</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default ProjectDashboard;